export default __webpack_public_path__ + "static/media/linkedin.af55caaf.svg";